import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit {
  // * ids Local Storage
  userName = localStorage.getItem('username');
  userIdLS = localStorage.getItem('userId');
  userRoleIdLS = localStorage.getItem('userRoleId');

  constructor(private router: Router) {}

  ngOnInit(): void {
    console.log('userName :>> ', this.userName);
    if (this.userIdLS != null) {
      console.log(this.userIdLS);
      this.userRoleIdLS = sessionStorage.getItem('sessionROLEId');
    } else {
      // reedirigir a login
      this.router.navigate(['/login']);
    }
  }
}
